import useProcessingEvents from '@/hooks/useProcessingEvents';
import { CvCResultFileInfo, resultFileListModel } from '@/stores/cvc';
import { MssExtendFileInfo, mssResultFileListModel } from '@/stores/mss';
import {
  cvcProcessingStatesModel,
  mssProcessingStatesModel,
} from '@/stores/resource';
import { useRecoilState, useSetRecoilState } from 'recoil';

// ISSUE-030 — route-independent job event subscription.
//
// useProcessingEvents used to be mounted inside route-scoped components
// (GeneratePanel on /cvc, SeparateControl on /mss), so navigating to the
// other page unmounted the subscription and silently dropped job_done /
// job_failed events — and, since ISSUE-022, the SESSION_CHANGED
// reconciliation triggers too. This bridge mounts one hook instance per
// model pair ABOVE the router (inside WebSocketContextProvider, above
// <Routes> in App.tsx), wired straight to the Recoil atoms, so events are
// handled no matter which route is active.
//
// Exactly-once semantics: both instances receive every event, but the hook's
// per-job guard (`if (!processingStatusRef.current[data.job_id]) return;`)
// makes each react only to job_ids in its own model's status map — one owner
// per event, and no fetches for job_ids the model does not track (review
// lesson: gate fetches on ids that own list entries).

const CvcJobEvents = () => {
  const setResultFileList = useSetRecoilState(resultFileListModel);
  const [processingStatus, setProcessingStatus] = useRecoilState(
    cvcProcessingStatesModel
  );
  useProcessingEvents<CvCResultFileInfo>(
    setResultFileList,
    processingStatus,
    setProcessingStatus
  );
  return null;
};

const MssJobEvents = () => {
  const setResultFileList = useSetRecoilState(mssResultFileListModel);
  const [processingStatus, setProcessingStatus] = useRecoilState(
    mssProcessingStatesModel
  );
  useProcessingEvents<MssExtendFileInfo>(
    setResultFileList,
    processingStatus,
    setProcessingStatus
  );
  return null;
};

const JobEventsBridge = () => {
  return (
    <>
      <CvcJobEvents />
      <MssJobEvents />
    </>
  );
};

export default JobEventsBridge;
